import { MenuList, MenuListProps } from "@mui/material";
import { MuiBox } from "../box/MuiBox";
import { MuiTypography } from "../typography/MuiTypography";
import { MuiMenuWrapper } from "./MuiMenuList.style";

import {
  MenuListParams,
  SaveSearchFilterParams,
} from "../../api/services/client/models";
import { ReactComponent as DeleteIcon } from "../../assets/images/delete-icon.svg";

import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import React from "react";
import { useNavigationSiteCore } from "../../hooks/useNavigationSiteCore";
import { COMPONENT_IDS } from "../../helpers/constants/componentIds";

interface MuiMenuProps extends MenuListProps {
  menuArray: MenuListParams[];
  open: boolean;
  onClose: () => void;
  refValue: HTMLButtonElement | null;
  onRowClick?: (item: MenuListParams | SaveSearchFilterParams) => void;
  onActionBtnClick?: (event: any, item: MenuListParams) => void;
}

export const MuiMenuList = (props: MuiMenuProps) => {
  const {
    menuArray,
    open,
    refValue: anchorRefValue,
    onClose,
    onRowClick,
    onActionBtnClick,
  } = props;

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === "Tab") {
      event.preventDefault();
      onClose?.();
    } else if (event.key === "Escape") {
      onClose?.();
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  const { commonARIALabel } = useNavigationSiteCore();
  React.useEffect(() => {
    if (anchorRefValue && prevOpen.current === true && open === false) {
      anchorRefValue.focus();
    }
    prevOpen.current = open;
  }, [anchorRefValue, open]);
  return (
    <MuiMenuWrapper>
      <Popper
        data-testid={COMPONENT_IDS.MENU_POPPER}
        open={open}
        anchorEl={anchorRefValue}
        role={undefined}
        placement="bottom"
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom-start" ? "left top" : "left bottom",
            }}
          >
            <Paper id="menu-paper">
              <ClickAwayListener onClickAway={onClose}>
                <MenuList
                  onKeyDown={handleListKeyDown}
                  autoFocusItem={open}
                  id="composition-menu"
                  disablePadding
                  aria-labelledby="composition-button"
                >
                  {menuArray.map((item, index) => {
                    return (
                      <MenuItem
                        disableGutters
                        key={`${item.id}-${index}`}
                        id={`menu-item-${index}`}
                        data-testid="menu-item"
                        onClick={(e) => {
                          onRowClick?.(item);
                        }}
                        className="no-padding"
                      >
                        <MuiBox
                          className="item-container"
                          id={`${item.id}-${index}`}
                        >
                          <MuiTypography className="item-text" variant="h3">
                            {item.name}
                          </MuiTypography>

                          <DeleteIcon
                            role="button"
                            onClick={(e) => {
                              onActionBtnClick?.(e, item);
                            }}
                            aria-label={commonARIALabel.delete}
                            className="notificationIcon"
                            data-testid={`delete-${index}`}
                          />
                        </MuiBox>
                      </MenuItem>
                    );
                  })}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </MuiMenuWrapper>
  );
};
